import separatorSvg from './separator.svg'

export const separator = separatorSvg
